import { DropdownWithStatistic } from "components";

import { StatisticCard } from "./components";
import { StatisticsOverviewCardsProps } from "./StatisticsOverviewCards.types";

import styles from "./StatisticsOverviewCards.module.scss";

const StatisticsOverviewCards = ({
  statistic,
  withComparativePeriod,
  isLoading,
  statisticForCompare,
  isLoadingForCompare
}: StatisticsOverviewCardsProps) => {
  return (
    <div>
      <DropdownWithStatistic label="Users statistic">
        <div className={styles["overview__separator--horizontal"]} />
        <div className={styles.overview}>
          <StatisticCard
            title="Users registered"
            totalAmount={statistic?.usersRegistered}
            comparablePeriodAmount={statisticForCompare?.usersRegistered}
            isLoading={isLoading}
            isLoadingForCompare={isLoadingForCompare}
            withComparativePeriod={withComparativePeriod}
          />
          <div className={styles["overview__separator--vertical"]} />
          <StatisticCard
            title="New buyers"
            totalAmount={statistic?.newBuyers}
            comparablePeriodAmount={statisticForCompare?.newBuyers}
            isLoading={isLoading}
            isLoadingForCompare={isLoadingForCompare}
            withComparativePeriod={withComparativePeriod}
          />
          <div className={styles["overview__separator--vertical"]} />
          <StatisticCard
            title="New resellers"
            totalAmount={statistic?.newResellers}
            comparablePeriodAmount={statisticForCompare?.newResellers}
            isLoading={isLoading}
            isLoadingForCompare={isLoadingForCompare}
            withComparativePeriod={withComparativePeriod}
          />

          <div className={styles["overview__separator--vertical"]} />
          <StatisticCard
            title="Completed verification resellers"
            totalAmount={statistic?.resellersWhoCompletedVerification}
            comparablePeriodAmount={
              statisticForCompare?.resellersWhoCompletedVerification
            }
            isLoading={isLoading}
            isLoadingForCompare={isLoadingForCompare}
            withComparativePeriod={withComparativePeriod}
          />
          <div className={styles["overview__separator--vertical"]} />
          <StatisticCard
            title="Didn't complete verification resellers"
            totalAmount={statistic?.resellersWhoDidNotCompleteVerification}
            comparablePeriodAmount={
              statisticForCompare?.resellersWhoDidNotCompleteVerification
            }
            isLoading={isLoading}
            isLoadingForCompare={isLoadingForCompare}
            withComparativePeriod={withComparativePeriod}
          />
        </div>
      </DropdownWithStatistic>

      <DropdownWithStatistic label="Orders statistic">
        <div className={styles["overview__separator--horizontal"]} />

        <div className={styles.overview}>
          <StatisticCard
            title="Scheduled orders"
            totalAmount={statistic?.ordersScheduled}
            comparablePeriodAmount={statisticForCompare?.ordersScheduled}
            isLoading={isLoading}
            isLoadingForCompare={isLoadingForCompare}
            withComparativePeriod={withComparativePeriod}
          />
          <div className={styles["overview__separator--vertical"]} />
          <StatisticCard
            title="Placed orders"
            totalAmount={statistic?.ordersPlaced}
            comparablePeriodAmount={statisticForCompare?.ordersPlaced}
            isLoading={isLoading}
            isLoadingForCompare={isLoadingForCompare}
            withComparativePeriod={withComparativePeriod}
          />
          <div className={styles["overview__separator--vertical"]} />
          <StatisticCard
            title="Delivered orders"
            totalAmount={statistic?.ordersDelivered}
            comparablePeriodAmount={statisticForCompare?.ordersDelivered}
            isLoading={isLoading}
            isLoadingForCompare={isLoadingForCompare}
            withComparativePeriod={withComparativePeriod}
          />
          <div className={styles["overview__separator--vertical"]} />
          <StatisticCard
            title="Failed orders"
            totalAmount={statistic?.ordersFailed}
            comparablePeriodAmount={statisticForCompare?.ordersFailed}
            isLoading={isLoading}
            isLoadingForCompare={isLoadingForCompare}
            withComparativePeriod={withComparativePeriod}
          />
          <div className={styles["overview__separator--vertical"]} />
          <StatisticCard
            title="Rescheduled orders"
            totalAmount={statistic?.ordersRescheduled}
            comparablePeriodAmount={statisticForCompare?.ordersRescheduled}
            isLoading={isLoading}
            isLoadingForCompare={isLoadingForCompare}
            withComparativePeriod={withComparativePeriod}
          />
        </div>
        <div className={styles["overview__separator--horizontal"]} />
        <div className={styles.overview}>
          <StatisticCard
            title="Canceled orders"
            totalAmount={statistic?.ordersCanceled}
            comparablePeriodAmount={statisticForCompare?.ordersCanceled}
            isLoading={isLoading}
            isLoadingForCompare={isLoadingForCompare}
            withComparativePeriod={withComparativePeriod}
          />
          <div className={styles["overview__separator--vertical"]} />
          <StatisticCard
            title="Canceled by ChapShop orders"
            totalAmount={statistic?.ordersCanceledByChapShop}
            comparablePeriodAmount={
              statisticForCompare?.ordersCanceledByChapShop
            }
            isLoading={isLoading}
            isLoadingForCompare={isLoadingForCompare}
            withComparativePeriod={withComparativePeriod}
          />
          <div className={styles["overview__separator--vertical"]} />
          <StatisticCard
            title="Canceled by user orders"
            totalAmount={statistic?.ordersCanceledByUser}
            comparablePeriodAmount={statisticForCompare?.ordersCanceledByUser}
            isLoading={isLoading}
            isLoadingForCompare={isLoadingForCompare}
            withComparativePeriod={withComparativePeriod}
          />
          <div className={styles["overview__separator--vertical"]} />
          <StatisticCard
            title="Placed orders with coupon"
            totalAmount={statistic?.ordersPlacedWithCoupon}
            comparablePeriodAmount={statisticForCompare?.ordersPlacedWithCoupon}
            isLoading={isLoading}
            isLoadingForCompare={isLoadingForCompare}
            withComparativePeriod={withComparativePeriod}
          />
          <div className={styles["overview__separator--vertical"]} />
          <StatisticCard
            title="Orders with unavailable items"
            totalAmount={statistic?.ordersWithUnavailableItems}
            comparablePeriodAmount={
              statisticForCompare?.ordersWithUnavailableItems
            }
            isLoading={isLoading}
            isLoadingForCompare={isLoadingForCompare}
            withComparativePeriod={withComparativePeriod}
          />
        </div>
        <div className={styles["overview__separator--horizontal"]} />
        <div className={styles.overview}>
          <StatisticCard
            title="Different products sold"
            totalAmount={statistic?.differentProductsSold}
            comparablePeriodAmount={statisticForCompare?.differentProductsSold}
            isLoading={isLoading}
            isLoadingForCompare={isLoadingForCompare}
            withComparativePeriod={withComparativePeriod}
          />
          <div className={styles["overview__separator--vertical"]} />
          <StatisticCard
            title="Average cart amount"
            totalAmount={statistic?.averageCartAmount}
            comparablePeriodAmount={statisticForCompare?.averageCartAmount}
            isLoading={isLoading}
            isLoadingForCompare={isLoadingForCompare}
            withComparativePeriod={withComparativePeriod}
          />
          <div className={styles["overview__separator--vertical"]} />
          <StatisticCard
            title="Loss of earnings due to coupons"
            totalAmount={statistic?.lossOfEarningsDueToCoupons}
            comparablePeriodAmount={
              statisticForCompare?.lossOfEarningsDueToCoupons
            }
            isLoading={isLoading}
            isLoadingForCompare={isLoadingForCompare}
            withComparativePeriod={withComparativePeriod}
          />
          <div className={styles["overview__separator--vertical"]} />
          <StatisticCard
            title="Margin (FCFA)"
            totalAmount={statistic?.margin}
            comparablePeriodAmount={statisticForCompare?.margin}
            isLoading={isLoading}
            isLoadingForCompare={isLoadingForCompare}
            withComparativePeriod={withComparativePeriod}
          />
          <div className={styles["overview__separator--vertical"]} />
          <StatisticCard
            title="Commission (FCFA)"
            totalAmount={statistic?.commission}
            comparablePeriodAmount={statisticForCompare?.commission}
            isLoading={isLoading}
            isLoadingForCompare={isLoadingForCompare}
            withComparativePeriod={withComparativePeriod}
          />
        </div>
      </DropdownWithStatistic>

      <DropdownWithStatistic label="Returns statistic">
        <div className={styles["overview__separator--horizontal"]} />

        <div className={styles.overview}>
          <StatisticCard
            title="Returns placed"
            totalAmount={statistic?.returnsPlaced}
            comparablePeriodAmount={statisticForCompare?.returnsPlaced}
            isLoading={isLoading}
            isLoadingForCompare={isLoadingForCompare}
            withComparativePeriod={withComparativePeriod}
          />
          <div className={styles["overview__separator--vertical"]} />
          <StatisticCard
            title="Returns approved"
            totalAmount={statistic?.returnsApproved}
            comparablePeriodAmount={statisticForCompare?.returnsApproved}
            isLoading={isLoading}
            isLoadingForCompare={isLoadingForCompare}
            withComparativePeriod={withComparativePeriod}
          />
          <div className={styles["overview__separator--vertical"]} />
          <StatisticCard
            title="Returns rejected"
            totalAmount={statistic?.returnsRejected}
            comparablePeriodAmount={statisticForCompare?.returnsRejected}
            isLoading={isLoading}
            isLoadingForCompare={isLoadingForCompare}
            withComparativePeriod={withComparativePeriod}
          />
          <div className={styles["overview__separator--vertical"]} />
          <StatisticCard
            title="Return rate"
            totalAmount={statistic?.returnRate}
            comparablePeriodAmount={statisticForCompare?.returnRate}
            isLoading={isLoading}
            isLoadingForCompare={isLoadingForCompare}
            withComparativePeriod={withComparativePeriod}
          />
        </div>
      </DropdownWithStatistic>

      <DropdownWithStatistic label="Deliveries statistic">
        <div className={styles["overview__separator--horizontal"]} />

        <div className={styles.overview}>
          <StatisticCard
            title="Deliveries started"
            totalAmount={statistic?.deliveriesStarted}
            comparablePeriodAmount={statisticForCompare?.deliveriesStarted}
            isLoading={isLoading}
            isLoadingForCompare={isLoadingForCompare}
            withComparativePeriod={withComparativePeriod}
          />
          <div className={styles["overview__separator--vertical"]} />
          <StatisticCard
            title="Deliveries canceled"
            totalAmount={statistic?.deliveriesCanceled}
            comparablePeriodAmount={statisticForCompare?.deliveriesCanceled}
            isLoading={isLoading}
            isLoadingForCompare={isLoadingForCompare}
            withComparativePeriod={withComparativePeriod}
          />
          <div className={styles["overview__separator--vertical"]} />
          <StatisticCard
            title="Deliveries failed"
            totalAmount={statistic?.deliveriesFailed}
            comparablePeriodAmount={statisticForCompare?.deliveriesFailed}
            isLoading={isLoading}
            isLoadingForCompare={isLoadingForCompare}
            withComparativePeriod={withComparativePeriod}
          />
          <div className={styles["overview__separator--vertical"]} />
          <StatisticCard
            title="Deliveries delivered"
            totalAmount={statistic?.deliveriesDelivered}
            comparablePeriodAmount={statisticForCompare?.deliveriesDelivered}
            isLoading={isLoading}
            isLoadingForCompare={isLoadingForCompare}
            withComparativePeriod={withComparativePeriod}
          />
        </div>

        <div className={styles["overview__separator--horizontal"]} />

        <div className={styles.overview}>
          <StatisticCard
            title="Delivery success rate"
            totalAmount={statistic?.deliverySuccessRate}
            comparablePeriodAmount={statisticForCompare?.deliverySuccessRate}
            isLoading={isLoading}
            isLoadingForCompare={isLoadingForCompare}
            withComparativePeriod={withComparativePeriod}
          />

          <div className={styles["overview__separator--vertical"]} />

          <StatisticCard
            title="Delivery failure rate"
            totalAmount={statistic?.deliveryFailureRate}
            comparablePeriodAmount={statisticForCompare?.deliveryFailureRate}
            isLoading={isLoading}
            isLoadingForCompare={isLoadingForCompare}
            withComparativePeriod={withComparativePeriod}
          />
        </div>
      </DropdownWithStatistic>
    </div>
  );
};

export default StatisticsOverviewCards;
